(function (window) {
  'use strict';

  if (window.FollettStoreSelection) return;

  var STORAGE_KEY = 'follett:selected-store:v1';
  var CHANGE_EVENT = 'follett:my-store-change';

  function normalizeValue(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function postalAddressText(postalAddress) {
    if (!postalAddress || typeof postalAddress !== 'object') return '';

    return [
      postalAddress.address_1 || postalAddress.address1 || postalAddress.streetAddress,
      postalAddress.city || postalAddress.addressLocality,
      postalAddress.region || postalAddress.state || postalAddress.addressRegion,
      postalAddress.postal_code || postalAddress.postalCode || postalAddress.zip,
      postalAddress.country || postalAddress.addressCountry
    ].filter(Boolean).join(' ');
  }

  function locationKey(location) {
    if (!location || typeof location !== 'object') return '';

    var explicitId = location.uid || location.id || location.location_id || location.locationId;
    if (explicitId) return 'id:' + normalizeValue(explicitId);

    var name = location.name || location.short_name || '';
    var address = location.address || location.formatted_address || postalAddressText(location.postal_address);
    var keyParts = [name, address];

    if (!name || !address) {
      keyParts.push(
        location.phone || '',
        location.email || '',
        location.lat || location.latitude || '',
        location.lng || location.longitude || ''
      );
    }

    var normalizedKey = keyParts.map(normalizeValue).filter(Boolean).join('|');
    return normalizedKey ? 'store:' + normalizedKey : '';
  }

  function read() {
    try {
      var rawSelection = window.sessionStorage.getItem(STORAGE_KEY);
      if (!rawSelection) return null;

      var selection = JSON.parse(rawSelection);
      if (!selection || typeof selection !== 'object' || !selection.location) return null;

      selection.key = selection.key || locationKey(selection.location);
      return selection.key ? selection : null;
    } catch (error) {
      return null;
    }
  }

  function resolve(locations) {
    if (!Array.isArray(locations) || !locations.length) return null;

    var selection = read();
    if (!selection) return null;

    for (var index = 0; index < locations.length; index += 1) {
      if (locationKey(locations[index]) === selection.key) {
        return {
          index: index,
          location: selection.location
        };
      }
    }

    return null;
  }

  function select(location) {
    var key = locationKey(location);
    if (!key) return null;

    var selection = {
      version: 1,
      key: key,
      location: location
    };

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
    } catch (error) {
      // The same-page event still keeps mounted store sections synchronized.
    }

    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, {
      detail: selection
    }));

    return selection;
  }

  window.FollettStoreSelection = {
    eventName: CHANGE_EVENT,
    keyFor: locationKey,
    read: read,
    resolve: resolve,
    select: select
  };
})(window);
